import { render, staticRenderFns } from "./Error403NotHeader.vue?vue&type=template&id=ac94992a&scoped=true&"
import script from "./Error403NotHeader.vue?vue&type=script&lang=ts&"
export * from "./Error403NotHeader.vue?vue&type=script&lang=ts&"
import style0 from "./Error403NotHeader.vue?vue&type=style&index=0&id=ac94992a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac94992a",
  null
  
)

export default component.exports